export const aboutData = {
  title: 'Engineering Profile',
  intro: "I'm a Full Stack Engineer with 4 years of professional experience building backend-first systems — APIs, event-driven architectures, multi-tenant SaaS platforms, and real-time communication systems.",
  paragraphs: [
    "My engineering approach starts from the backend. I think about data flow, API contracts, system boundaries, and asynchronous workflows before I think about the UI. Most of the interesting problems I work on live in the space between services — in how events propagate, how queues are managed, how multi-tenant data is isolated, and how AI and telephony systems are wired into business workflows.",
    "Over the past 4 years I have worked across the full stack — from React and Next.js frontends, to Node.js and Python backends, to PostgreSQL schemas, to RabbitMQ event pipelines, to AI and Voice integrations. I have contributed to CRM platforms, lead intelligence systems, LMS applications, and conversational AI products.",
    "I am comfortable working at the intersection of backend engineering, API design, distributed systems, and AI tooling. I prefer building systems that are maintainable, well-structured, and grounded in real business requirements."
  ],
  areas: [
    'Backend Engineering',
    'API Design',
    'Event-Driven Architecture',
    'Distributed Systems',
    'Multi-Tenant SaaS',
    'Real-Time Systems',
    'AI Integrations',
    'Conversational AI',
    'CRM Platforms',
    'Workflow Automation',
  ]
}